import React, { useContext, useEffect, useState } from "react";

// images
import logo from "../../images/header-logo.png";

// context
import { UserData } from "../../contexts/UserInfoContext";

// components
import Searchbar from "./Searchbar";
import MenuOption from "./MenuOption";
import Navbar from "./Navbar";
import { Link } from "react-router-dom";
import { getItemStorage } from "../../Localstorage/useLocalStorage";
import Loading from "../shared/Loading";
import CircleLoading from "../shared/CircleLoading";
import { toFarsiNumber } from "../../helper/helper";
import { CartDataContext } from "../../contexts/CartContext";

const Header = ({ className, headerRef }) => {
  const { user, userLoaded, err } = useContext(UserData);
  const [userLoading, setUserLoading] = useState(true);
  const { cart, setCart, updateCart } = useContext(CartDataContext);

  const token = getItemStorage("token");

  useEffect(() => {
    userLoaded && setUserLoading(false);
    err.msg && setUserLoading(false);
    !token && setUserLoading(false);
  }, [userLoaded]);

  return (
    <header ref={headerRef} className={`w-full bg-[#151515] flex justify-center ${className}`}>
      <div className="w-full xl:max-w-[1300px] h-[52px] hidden lg:flex justify-between items-center gap-6 px-3 2xl:px-0">
        <div className="flex items-center">
          <div className="header-items flex items-center gap-10 py-4">
            <div className="flex items-center gap-14">
              {/* header logo */}
              <div className="header-logo w-16 border-l border-gray-700 pl-2">
                {/* <h1 className="text-xl text-yellow-700 font-black">
                  یونی بست من
                </h1> */}
                <img src={logo} alt="" />
              </div>

              {/* header searchbar */}
              {/* <Searchbar /> */}
            </div>

            {/* header option */}
            {/* <MenuOption user={user} userLoaded={userLoaded} err={err} /> */}
          </div>

          {/* header navbar */}
          <div className="flex items-center gap-3">
            <Navbar />

            {/* <button className="flex relative group hover:text-yellow-700 items-center text-sm justify-center gap-2 py-2 px-3 w-fit text-gray-100 transition-all duration-300">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-[18px] h-[18px] stroke-gray-100 group-hover:stroke-yellow-700"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
                />
              </svg>
            </button> */}
          </div>
        </div>

        {/* left side navbar */}
        <div className="flex items-center gap-4">
          <Link
            to={"/favourite"}
            className="flex relative group hover:text-yellow-700 items-center text-sm justify-center gap-1 w-fit text-gray-100 transition-all duration-300"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-[18px] h-[18px] stroke-gray-100 group-hover:stroke-yellow-700"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z"
              />
            </svg>

            <span>علاقه مندی</span>
          </Link>

          <Link
            to={"/cart"}
            className="flex relative group hover:text-yellow-700 items-center text-sm justify-center gap-1 w-fit text-gray-100 transition-all duration-300"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-[18px] h-[18px] stroke-gray-100 group-hover:stroke-yellow-700"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 0 0-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 0 0-16.536-1.84M7.5 14.25 5.106 5.272M6 20.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm12.75 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"
              />
            </svg>

            <span>سبد خرید</span>

            <span className="absolute text-sm -top-[9px] -right-[10px] flex justify-center items-center w-5 h-5 bg-yellow-700 text-white rounded-full">
              {cart.items
                ? toFarsiNumber(cart.items.length)
                : toFarsiNumber("0")}
            </span>
          </Link>

          <Link
            to={
              user.user && userLoading ? "" : user?.user?.id ? "/user" : "/auth"
            }
            className="w-fit px-6 h-10 text-sm flex items-center justify-center text-white bg-gradient-to-tl from-green-600 to-green-300 rounded-xl shadow-lg"
          >
            {userLoading ? (
              <CircleLoading />
            ) : !userLoading && user.info ? (
              <span className="user-name text-lg">
                {user.user.name + " " + user.user.family_name}
              </span>
            ) : (
              <span>ورود یا ثبت نام</span>
            )}
          </Link>
        </div>
      </div>
    </header>
  );
};

export default Header;
